<div class="info-container" *ngIf="coach">
    <div class="coach-desktop-profile-photo">
        <app-inline-svg *ngIf="coach.file === null" [file]="'assets/img/user-blue.svg'" ></app-inline-svg>
        <img *ngIf="coach.file !== null" [src]="coach.file.url" />
    </div>
    <div class="coach-profile-header">
        <div class="coach-info">
            <div class="coach-profile-photo">
                <app-inline-svg *ngIf="coach.file === null" class="img" [file]="'assets/img/user-blue.svg'" ></app-inline-svg>
                <img *ngIf="coach.file !== null" [src]="coach.file.url" />
            </div>
            <div class="coach-description">
                <div class="coach-name">{{coach.full_name}}</div>
                <div class="coach-speciality my-color-blue">{{coach.job_title}}</div>
            </div>
        </div>

        <div class="coach-calendar">
            <div>{{'__COACH_PROFILE_BOOKING_TEXT__' | translate}}</div>
            <a (click)="gotoCalendar()">
                <app-inline-svg class="img" [file]="'assets/img/coach-calendar.svg'"></app-inline-svg>
            </a>
        </div>
    </div>

    <div class="left-column">
        <div class="back-to-profiles" (click)="gotoBack()">
            <app-inline-svg class="img" [file]="'assets/img/back-blue.svg'" alt="" ></app-inline-svg>
            <div class="text">{{'__COACH_PROFILE_BACK_TEXT__' | translate}}</div>
        </div>
        <div class="coach-groups" *ngIf="!!coach.competencies && coach.competencies.length">
            <div class="coach-groups-title my-color-blue">{{'__COACH_PROFILE_TOPICS__' | translate}}</div>
            <div *ngFor="let competency of coach.competencies" class="text">
                {{competency.framework_template_competency.title}}
            </div>
        </div>
    </div>

    <div class="coach-data">
        <div [innerHTML]="coach.description"></div>
        <button class="btn-rounded-blue primary-bg-color" (click)="gotoCalendar()">
            {{'__COACH_PROFILE_BOOKING_TEXT__' | translate}}
        </button>
    </div>
</div>

<div class="info-container" *ngIf="!coach">
    <div class="coach-desktop-profile-photo">
        <ion-skeleton-text animated></ion-skeleton-text>
    </div>
    <div class="coach-profile-header">
        <div class="coach-info">
            <div class="coach-profile-photo">
                <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="coach-description">
                <div class="coach-name"><ion-skeleton-text animated></ion-skeleton-text></div>
                <div class="coach-speciality"><ion-skeleton-text animated></ion-skeleton-text></div>
            </div>
        </div>

        <div class="coach-calendar" *ngIf="coach">
            <div>{{'__COACH_PROFILE_BOOKING_TEXT__' | translate}}</div>
            <a (click)="gotoCalendar()">
                <img src="assets/img/coach-calendar.svg" />
            </a>
        </div>
        <div class="coach-calendar" *ngIf="!coach">
            <ion-skeleton-text animated style="width: 8.5rem; height: 2rem;"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 8.5rem; height: 8.5rem; border-radius: 100%; "></ion-skeleton-text>
        </div>
    </div>

    <div class="left-column">
        <div class="back-to-profiles" (click)="gotoBack()">
            <img src="assets/img/back-blue.svg" alt="" />
            <div class="text">{{'__COACH_PROFILE_BACK_TEXT__' | translate}}</div>
        </div>
    </div>

    <div class="coach-data">
        <ion-skeleton-text animated *ngFor="let i of [1,2,3]"></ion-skeleton-text>
    </div>
</div>
